import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Folder } from '../../api/documents';

export function FolderManagerPage() {
  const [folders, setFolders] = useState<Folder[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.listFolders().then((r) => setFolders(r.folders)).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Folder Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-2">
        {folders.map((f) => (
          <li key={f.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{f.name}</span>
              <span className="text-xs text-slate-500">{f.path}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
